<p-panel>
    <div class="container-fluid gap-5">
        <div class="row">
            <div class="col">
                <app-reactive-form-builder
                    #builderRef
                    (formChanges)="formChanges($event[0], $event[1])"
                    (afterSend)="onAfterSend($event)"
                    (goBack)="goBack()"
                    [form]="form.formFields"
                    [serverUrl]="form.env.serverUrl"
                    [dropdownLoadTrigger]="dropdownLoadTrigger"
                    [id]="(getModel().id)?.toString() ?? ''"
                    [dropdownsFinalized]="dropdownsFinalized"
                    [request]="this.getType() === 1 ? this.stockApi.entradas.PUT : this.stockApi.entradas.POST"
                    [getRequest]="this.stockApi.entradas.GET">
                </app-reactive-form-builder>
            </div>
        </div>
    </div>
</p-panel>